import { render, staticRenderFns } from "./PeopleOneHelath.vue?vue&type=template&id=31a0c0a2&"
import script from "./PeopleOneHelath.vue?vue&type=script&lang=js&"
export * from "./PeopleOneHelath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports